import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges } from '@angular/core';
import { SvgComponent } from '../../shared/components/svg/svg.component';

@Component({
  selector: 'app-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './badge.component.html',
  styleUrl: './badge.component.scss',
  imports: [SvgComponent],
})
export class BadgeComponent implements OnChanges {
  @HostBinding('class') elementClass: string;
  @HostBinding('style.--badge-color') badgeColor: string;
  @HostBinding('style.--badge-bg-color') badgeBackgroundColor: string;
  @Input() icon: string;
  @Input() interactable = false;
  @Input({ required: true }) color: 'primary' | 'green' | 'red' | 'orange' | 'grey-50' | 'grey-60' | 'grey-80';
  @Input() backgroundColor: 'transparent' | 'white' | 'grey-80' | 'grey-90' = 'white';
  @Input() stroke = false;

  ngOnChanges(): void {
    this.badgeColor = `var(--color-${this.color})`;

    if (['transparent', 'white'].includes(this.backgroundColor)) {
      this.badgeBackgroundColor = this.backgroundColor;
    } else {
      this.badgeBackgroundColor = `var(--color-${this.backgroundColor})`;
    }

    if (this.stroke) {
      this.elementClass = 'stroke';
    }

    if (this.interactable) {
      this.elementClass = 'clickable';
    } else {
      this.elementClass = '';
    }
  }
}
